/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertReservationNotificationRequest
 */
export interface UpsertReservationNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertReservationNotificationRequest
     */
    customizableEmailText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertReservationNotificationRequest
     */
    notifyBySms?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertReservationNotificationRequest
     */
    notifyByWhatsapp?: boolean;
}

/**
 * Check if a given object implements the UpsertReservationNotificationRequest interface.
 */
export function instanceOfUpsertReservationNotificationRequest(value: object): value is UpsertReservationNotificationRequest {
    return true;
}

export function UpsertReservationNotificationRequestFromJSON(json: any): UpsertReservationNotificationRequest {
    return UpsertReservationNotificationRequestFromJSONTyped(json, false);
}

export function UpsertReservationNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertReservationNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customizableEmailText': json['customizableEmailText'] == null ? undefined : json['customizableEmailText'],
        'notifyBySms': json['notifyBySms'] == null ? undefined : json['notifyBySms'],
        'notifyByWhatsapp': json['notifyByWhatsapp'] == null ? undefined : json['notifyByWhatsapp'],
    };
}

export function UpsertReservationNotificationRequestToJSON(json: any): UpsertReservationNotificationRequest {
    return UpsertReservationNotificationRequestToJSONTyped(json, false);
}

export function UpsertReservationNotificationRequestToJSONTyped(value?: UpsertReservationNotificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customizableEmailText': value['customizableEmailText'],
        'notifyBySms': value['notifyBySms'],
        'notifyByWhatsapp': value['notifyByWhatsapp'],
    };
}

